import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  type: 'overallPerformanceSubBranch',
  currentYear: '',
  currentQuarter: '',
  selectedYear: '',
  selectedQuarter: '',
  compareSelectedYear: '',
  compareSelectedQuarter: '',

  // compareSelectedYearForYTD: '',
  // compareSelectedQuarterForYTD: '',
  overallPerformanceSubBranchRange: {
    start_week: null,
    start_year: null,
    end_week: null,
    end_year: null,
  },
  compareOverallPerformanceSubBranchRangeTableOne: {
    start_week: null,
    start_year: null,
    end_week: null,
    end_year: null,
  },
  overallPerformanceYTDSubBranchRange: {
    start_week: null,
    start_year: null,
    end_week: null,
    end_year: null,
  },
  compareOverallPerformanceSubBranchRangeYTD: {
    start_week: null,
    start_year: null,
    end_week: null,
    end_year: null,
  },
};

const overallPerformanceSubBranchSlice = createSlice({
  name: 'overallPerformanceSubBranch',
  initialState,
  reducers: {
    setCurrentQuarter: (state, action) => ({ ...state, currentQuarter: action.payload }),
    setCurrentYear: (state, action) => ({ ...state, currentYear: action.payload }),
    setSelectedQuarter: (state, action) => ({ ...state, selectedQuarter: action.payload }),
    setSelectedYear: (state, action) => ({ ...state, selectedYear: action.payload }),
    setCompareSelectedYear: (state, action) => ({ ...state, compareSelectedYear: action.payload }),
    setCompareSelectedQuarter: (state, action) => ({
      ...state,
      compareSelectedQuarter: action.payload,
    }),
    setOverallPerformanceRange: (state, action) => ({
      ...state,
      overallPerformanceSubBranchRange: action.payload,
    }),
    setOverallPerformanceYTDRange: (state, action) => ({
      ...state,
      overallPerformanceYTDSubBranchRange: action.payload,
    }),
    setCompareOverallPerformanceRangeForTableOne: (state, action) => ({
      ...state,
      compareOverallPerformanceSubBranchRangeTableOne: action.payload,
    }),
    setCompareOverallPerformanceRangeYTD: (state, action) => ({
      ...state,
      compareOverallPerformanceSubBranchRangeYTD: action.payload,
    }),
  },
});

export const overallPerformanceSubBranchActions = overallPerformanceSubBranchSlice.actions;

export default overallPerformanceSubBranchSlice.reducer;
